import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Redirect, Route, Switch } from 'react-router-dom'
import Marketing from './marketing'

const path = '/main/marketing'

export const MARKETING_HOME = path + '/home'

export default (props: RouteComponentProps) => (
    <Switch>
        <Route path={MARKETING_HOME} component={Marketing} />
        <Redirect to={MARKETING_HOME} />
    </Switch>
)
